import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function SubcontractorFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.subcontractor.filter);

  const pageMessages = messages[lang].subcontractorListFilters;

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_SUBCONTRACTOR_FILTER',
      payload: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
      dispatch({
        type: 'GET_SUBCONTRACTORS',
        page: 0,
        filter: filters,
        cleanTable: true
      })
    }
  }

  return (
    <Form className="px-3">
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.cnpj}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.cnpj}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, cnpj: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.email}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.email}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, email: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.nomeFantasia}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.nomeFantasia}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, nomeFantasia: event.target.value },
                    )}
                />
        </Form.Group>

        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.razaoSocial}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.razaoSocial}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, razaoSocial: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>
    </Form>
  );
}
